import * as React from 'react';

import {
    Col,
    Container,
    Row
} from 'reactstrap';
import { AccountingPkgPresentation } from '../SelectAccountingSystem/AccountingPkgPresentation';

import { SelectAccountingSystem } from '../SelectAccountingSystem/SelectAccountingSystem';
import { BorrowerPortalChildProps } from './BorrowerPortalV2';

type Props = {
    borrowerPortalProps: BorrowerPortalChildProps;
    importFinancials: (accountingPkg: AccountingPkgPresentation) => void;
    tabIndexBase: number;
}

export const NewImportWidget: React.FC<Props> = (props): React.ReactElement => {
    const {
        borrowerPortalProps,
        importFinancials,
        tabIndexBase,
    } = props;

    return (
        <Container fluid>
            <Row>
                <Col xs={12} className={'centered-col'}>
                    <SelectAccountingSystem
                        buttonsDisabled={borrowerPortalProps.working}
                        onLink={importFinancials}
                        rowClass={'borrower-content-row'}
                        tabIndexBase={tabIndexBase}
                    />
                </Col>
            </Row>
        </Container>
    )
}
